import React from 'react';
import { isAudioElement, isTextLinkImageOrVideo, isUiModelIsAttachment } from '@src/slide/domain/ui-model/elements/element-judge';
import NormalAttachmentToolbar, { NormalAttachmentToolbarProps } from './normal';
import { AttachmentToolbarProps as DcAttachmentToolbarProps } from '@src/slide/domain/ui-model/element-modeles/property/attachment/interface';
import PreviewAttachmentToolBar from './preview';
import { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';
import { IPictureModel } from '@src/slide/domain/ui-model/element-modeles/Interface/picture-model.interface';
import AudioToolBar from './audio';


type AttachmentToolbarProps = NormalAttachmentToolbarProps & DcAttachmentToolbarProps;
export default function AttachmentToolbar(props: AttachmentToolbarProps) {
    const { selectedModel, pptEditorState } = props;
    if (!selectedModel) {
        return null;
    }
    if (!isUiModelIsAttachment(selectedModel)) {
        return null;
    }
    if (isShowPreviewToolbar(selectedModel)) {
        return <PreviewAttachmentToolBar selectedModel={selectedModel} pptEditorState={pptEditorState} />;
    }
    if (isAudioElement(selectedModel)) {
        return <AudioToolBar selectedModel={selectedModel as IPictureModel} pptEditorState={pptEditorState}/>;
    }
    return <NormalAttachmentToolbar selectedModel={selectedModel} shadow pptEditorState={pptEditorState}/>;
}

/**
 * 判断是否显示预览小窗工具栏
 * @param model
 * @returns
 */
export function isShowPreviewToolbar(model: IPictureModel | IShapeModel) {
    return isTextLinkImageOrVideo(model);
}
